import { Assignment, Device } from '@order-management/types';
import { removeDuplicates } from '../shared/utils';

const NO_SOFTWARE_ASSIGNED = 'No software assigned yet';

export function getDeviceName(
  device: Pick<Device, 'name' | 'defaultName' | 'serialNumber'>
) {
  return (
    device.name || device.defaultName || device.serialNumber?.number || ''
  );
}

/** Returns the sorted software titles assigned to a device, including the ones selected to be assigned */
export function getAssignedSoftware(
  assignments: Assignment[],
  selectedSoftware: string[] = []
) {
  const assignedSoftwareTitles = assignments
    .filter((assignment) => assignment.softwareSeat)
    .map(
      (assignment) => assignment.softwareSeat.licensingProductGroup.displayName
    );

  if (assignedSoftwareTitles.length === 0 && selectedSoftware.length === 0) {
    return NO_SOFTWARE_ASSIGNED;
  }

  return removeDuplicates([...selectedSoftware, ...assignedSoftwareTitles])
    .sort()
    .join(', ');
}
